<div class="product-image-modal-container">
  <div class="modal-container">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="closeModal('Cross click')">
          <mat-icon svgIcon="modal-x-icon"></mat-icon>
        </button>
      </div>
      <div class="modal-body">
        <div class="image custom-image-wrapper">
          <cx-media
            class="product-image-modal"
            [container]="getImageRendition(modalData?.url)"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
        </div>
      </div>
    </div>
  </div>
</div>
